<template>
    <vuetiful-form :form="form" @startSubmit="toggleLoader" @success="success" @error="error" :class="{'is-submitting': showLoader}">
        <slot/>
        <template v-if="!showLoader" slot="button-text">
            <slot name="button-text"/>
        </template>
        <template v-else slot="button-text">
            <loading-indicator/>
        </template>
    </vuetiful-form>
</template>

<script>
    import VuetifulForm     from "vuetiful-forms/src/components/VuetifulForm";
    import LoadingIndicator from "./LoadingIndicator";

    export default {
        name      : "FormWithLoader",
        components: { LoadingIndicator, VuetifulForm },
        extends   : VuetifulForm,

        data() {
            return {
                showLoader: false,
            };
        },

        methods: {
            toggleLoader() {
                this.showLoader = !this.showLoader;
            },

            error(error) {
                this.toggleLoader();
                this.$emit('error', error);
            },
            success(response) {
                this.$emit('success', response);
                this.toggleLoader();
            }
        },
    }
</script>

<style scoped lang="scss">

</style>
